/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTiposBodegasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTiposBodegas: React.FunctionComponent<ITablaTiposBodegasVistaProps & InjectedIntlProps> = ({
    tiposBodegass,
    cargarTiposBodegas,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tiposBodegass}
            actions={acciones(manejarFormulario, cargarTiposBodegas, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTiposBodegas);
